//Components
import Tree from './Tree'
import Item from './Item'

export default Object.assign(
  Tree,
  { Item }
)